import { render } from "./CollectionButton.vue?vue&type=template&id=ca1cb452&scoped=true"
import script from "./CollectionButton.vue?vue&type=script&lang=js"
export * from "./CollectionButton.vue?vue&type=script&lang=js"

import "./CollectionButton.vue?vue&type=style&index=0&id=ca1cb452&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca1cb452"]])

export default __exports__